import * as Yup from 'yup'
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const editUserSchema = Yup.object({
    name: Yup.string().min(3, 'Length of Name must be between 3 and 30 letters').max(30, 'Length of Name must be between 3 and 30 letters').required('Required'),
    contact: Yup.string().required('Required'),
    biography: Yup.string().required('Required'),
    // booksInfo: Yup.string().required('Required')
})

export const changePasswordSchema = Yup.object({
    old: Yup.string().required('Required'),
    password: Yup.string().required('Required'),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], 'Password Does Not Match').required('Required'),
})

export const addBookSchema = Yup.object({
    title: Yup.string().required('Required'),
    cover: Yup.string().required('Required'),
    category: Yup.string().required('Required'),
    story: Yup.string().required('Required')
})